function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useState, useEffect, useCallback, forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { fontStyle, spacing, borderRadius, themeLight } from '@naf/theme';
import { Dropdown } from './dropdown';
import { Text } from '@naf/text';
import { propValidationConfig } from '../../propValidationConfig';
export const Phone = /*#__PURE__*/forwardRef(({
  countries,
  selectedCountry,
  preferredCountries,
  value,
  onChange,
  onSubmit,
  error = false,
  placeholder,
  disabled = false,
  ariaLabel,
  width = 256,
  className,
  ...rest
}, ref) => {
  const [number, setNumber] = useState('');
  const [isFocused, setIsFocused] = useState(false);
  const [selected, setSelected] = useState(selectedCountry);
  const setFocus = useCallback(() => {
    setIsFocused(true);
  }, [setIsFocused]);
  const loseFocus = useCallback(() => {
    setIsFocused(false);
  }, [setIsFocused]);
  const handleChange = e => {
    if (!onChange) return;
    setNumber(e.target.value);
    onChange({
      code: selected.code,
      number: e.target.value
    });
  };
  useEffect(() => {
    if (value) {
      setNumber(value);
    }
    return;
  }, [value]);
  return /*#__PURE__*/React.createElement(Container, {
    ref: ref,
    className: className,
    width: width,
    focus: isFocused,
    error: error,
    disabled: disabled
  }, countries && countries.length > 1 && /*#__PURE__*/React.createElement(Dropdown, {
    disabled: disabled,
    width: width,
    countries: countries,
    preferredCountries: preferredCountries,
    selected: selected,
    handleSelect: country => setSelected(country)
  }), countries && countries.length === 1 && /*#__PURE__*/React.createElement(CountryCode, null, "(+", countries[0].code, ")"), /*#__PURE__*/React.createElement(PhoneInput, _extends({
    value: number,
    disabled: disabled,
    placeholder: placeholder,
    onChange: handleChange,
    "aria-label": ariaLabel,
    type: "tel",
    onFocus: setFocus,
    onBlur: loseFocus
  }, rest)));
});
export default Phone;
const Container = styled.div.withConfig(propValidationConfig).withConfig({
  displayName: "phone__Container",
  componentId: "sc-bk1r6f-0"
})(["height:", ";display:flex;flex-direction:row;position:relative;align-items:center;width:", "px;background:", ";border:1px solid ", ";box-sizing:border-box;border-radius:", ";*{font-variant-numeric:lining-nums !important;}", " ", " ", ""], spacing.space48, props => props.width, ({
  theme
}) => theme.background ? theme.background.default : themeLight.background.default, ({
  theme
}) => theme.border ? theme.border.heavy : themeLight.border.heavy, borderRadius.M, ({
  focus,
  error
}) => focus && !error && css(["border:2px solid;> div,p{margin-left:-1px;}"]), ({
  error
}) => error && css(["border:2px solid ", ";~ div{margin-left:-1px;}"], ({
  theme
}) => theme.componentColors ? theme.componentColors.alert.error : themeLight.componentColors.alert.error), ({
  disabled
}) => disabled && css(["background-color:", ";border-color:", ";color:", ";-webkit-text-fill-color:", ";opacity:1;"], ({
  theme
}) => theme.componentColors ? theme.componentColors.inputElement.backgroundDisabled : themeLight.componentColors.inputElement.backgroundDisabled, ({
  theme
}) => theme.border ? theme.border.heavy : themeLight.border.heavy, ({
  theme
}) => theme.typography ? theme.typography.disabledText : themeLight.typography.disabledText, ({
  theme
}) => theme.typography ? theme.typography.disabledText : themeLight.typography.disabledText));
const PhoneInput = styled.input.withConfig(propValidationConfig).withConfig({
  displayName: "phone__PhoneInput",
  componentId: "sc-bk1r6f-1"
})(["background:transparent;border:none;overflow:auto;padding-left:", ";height:calc(100% - 2px);", ";&:focus:not([disabled]){outline:none;}::placeholder{color:", ";}", ""], spacing.space12, fontStyle.article.articleText, ({
  theme
}) => theme.typography ? theme.typography.subtleText : themeLight.typography.subtleText, ({
  disabled
}) => disabled && css(["cursor:not-allowed;"]));
const CountryCode = styled(Text).withConfig({
  displayName: "phone__CountryCode",
  componentId: "sc-bk1r6f-2"
})(["margin:0;padding-left:", ";"], spacing.space8);
//# sourceMappingURL=index.js.map